import { Link } from "react-scroll";
import Section from "./Section";

const AboutSection = () => {
	return (
		<Section id="about" label="About" bgClass="about-bg">
			{(visible) => (
				<div className="section-content animate-on-scroll">
					{/* Left side */}
					<div className="section-left">
						<div className="left-content-box">
							<div className="text-bg">
								<h2
									className={`left-title ${visible ? "animate-title" : ""}`}
									style={{
										animationDelay:
											visible
												? "0.2s"
												: "0s",
									}}
								>
							Reliable Structural Framing You Can Count On
								</h2>
								<p
									className={`left-desc ${visible ? "animate-desc" : ""}`}
									style={{
										animationDelay:
											visible
												? "0.7s"
												: "0s", // 0.5s after title
									}}
								>
									California Framing delivers high-quality wood and structural framing for residential and commercial construction across Southern California. We focus on building strong, accurate, and code-compliant structures that provide a solid foundation for every project.
									<br />
									<br />
									With a commitment to precision and efficiency, our team works closely with contractors and builders to ensure smooth execution from start to finish. Every phase is handled with attention to detail, clear communication, and a focus on staying on schedule so your project moves forward without delays.
								</p>
							</div>
						</div>
					</div>

					<div className="section-divider" />

					{/* Right side */}
					<div className="section-right">
						<div
							className={`right-content ${visible ? "animate-right" : ""}`}
							style={{
								animationDelay:
									visible
										? "0.2s"
										: "0s",
							}}
						>
							<h3>
								<br />
								Why Choose California
								Framing?
							</h3>
							{/* TODO: maybe remove style given doesnt look like it so */}
							<ul
								style={{
									listStyle: "disc",
								}}
							>
								<li>Skilled framing professionals with real job site experience</li>
								<li>Built to meet strict safety standards and local building codes</li>
								<li>Reliable timelines, on-time scheduling, and efficient project completion</li>
							</ul>

							<h3>
								{" "}
								Quality Framing That Lasts
							</h3>
							<p>
				We focus on precision, durability, and clear communication on every project. From new construction to additions and remodels, <strong>California Framing</strong> delivers reliable structural framing built for long-term performance.
							</p>
						</div>
						<div
							className={`right-cta ${visible ? "animate-right-cta" : ""}`}
							style={{
								animationDelay:
									visible
										? "0.7s"
										: "0s", // 0.5s after right text
							}}
						>
							<Link to="contact" smooth={true} duration={500} offset={-70}>
	                    		<button className="cta-btn">Reach Out Now</button>
							</Link>
						</div>
					</div>
				</div>
			)}
		</Section>
	);
};

export default AboutSection;
